/* eslint-disable react/display-name */
import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import {
  initializeCanvas,
  destroyCanvas,
  setDrawMode,
  redrawCanvas,
  getUserDrawings
} from './doc-canvas';

const DocWriterWrapper = forwardRef((props, ref) => {
  const canvasRef = useRef(null);
  const bgCanvasRef = useRef(null);

  const styles = {
    canvasContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      // width: '100vw',
      // height: 'calc(100vh - 80px)',
      // minHeight: 'calc(100vh - 80px)',
      // maxHeight: 'calc(100vh - 80px)',
      position: 'relative'
    },
    canvas: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      overflowClipMargin: 'borderBox'
    }
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const bgCanvas = bgCanvasRef.current;

    const handleOnNotifyImageLoad = (msg) => {
      redrawCanvas();
    };

    if (canvas && bgCanvas) {
      initializeCanvas(canvas, bgCanvas, props.imageUrl, props.drawings, handleOnNotifyImageLoad);
    }

    // Clean up
    return () => {
      if (canvas && bgCanvas) {
        destroyCanvas(canvas, bgCanvas);
      }
    };
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const bgCanvas = bgCanvasRef.current;

    if (canvas && bgCanvas) {
      initializeCanvas(canvas, bgCanvas, props.imageUrl, props.drawings);
    }
  }, [props.imageUrl]);

  useImperativeHandle(ref, () => {
    const enableDrawMode = () => {
      setDrawMode('draw');
      redrawCanvas();
    };
    const enableEraseMode = () => {
      setDrawMode('erase');
      redrawCanvas();
    }
    const getDrawings = () => {
      return getUserDrawings();
    }

    return {
      enableDrawMode,
      enableEraseMode,
      getDrawings
    };
  });

  return (
    <div style={styles.canvasContainer}>
      <canvas
        ref={canvasRef}
        id="canvas"
        style={{
          overflowClipMargin: 'borderBox'
        }}
      >
        Your browser does not support HTML5 canvas
      </canvas>
      <canvas
        ref={bgCanvasRef}
        id="bgCanvas"
        style={styles.canvas}
        src="https://quantumtrader.s3.amazonaws.com/fsdemo.png"
        alt="Background Image"
      />
    </div>
  );
});

export default DocWriterWrapper;
